import React, { useEffect, useState, useRef } from 'react';
import { FaBrain, FaFileAlt, FaKeyboard, FaRegCopy, FaRobot, FaChevronDown, FaChevronRight, FaAppStore, FaDatabase, FaProjectDiagram, FaLayerGroup, FaFilter, FaPalette, FaCogs, FaSitemap, FaMemory, FaSearch, FaSearchPlus, FaColumns, FaRocket, FaServer } from 'react-icons/fa';
import { VscAzure } from "react-icons/vsc";
import {
  SiGooglegemini,
  SiOllama
} from 'react-icons/si';
import { BsOpenai } from 'react-icons/bs';
import { MdGridView } from "react-icons/md";
import { GrDocumentUpdate } from 'react-icons/gr'
import { FaNetworkWired } from "react-icons/fa";
import UtilService from '../../services/api/Utils';
import mcpIcon from '../../assets/img/mcp.png';
import WorkflowService from '../../services/api/workflow';
import TaskEngineIcon from '../agents/TaskEngineIcon';
import AgentApps from '../../pages/agentapps/AgentApps';
import logo_icon from '../../assets/img/logo_icon.png';
import '../../assets/css/agentapps.css';
import ToolIcon from '../Custom/ToolIcon';
import litellmIcon from '../../assets/img/litellm.png';
import customLlmIcon from '../../assets/img/custom-llm.svg';
import { isCustomLlmType } from './workflowUtils';

const ioTypes = [
  { type: 'input', label: 'Input', icon: <FaKeyboard />, color: '#4880FF', iconColor: '#4880FF', data: { inputType: 'text' } },
];

const agentTypes = [
  { type: 'agent', label: 'Custom', color: '#8D33FF', icon: <FaNetworkWired />, disabled: false },
  { type: 'agent', label: 'Extract', color: '#FF8C33', icon: <GrDocumentUpdate />, disabled: false },
  { type: 'agent', label: 'Task Agent', color: '#FF8C33', icon: <TaskEngineIcon size="sm" />, disabled: false },
]

const vectorStoreTypes = [
  { type: 'vector', label: 'Pinecone', color: '#0FB9B1', icon: <FaDatabase />, disabled: false },
  { type: 'vector', label: 'Weaviate', color: '#1E90FF', icon: <FaProjectDiagram />, disabled: false },
  { type: 'vector', label: 'Milvus', color: '#FF6B6B', icon: <FaLayerGroup />, disabled: false },
  { type: 'vector', label: 'Qdrant', color: '#6C5CE7', icon: <FaFilter />, disabled: false },
  { type: 'vector', label: 'Chroma', color: '#F9A825', icon: <FaPalette />, disabled: false },

  { type: 'vector', label: 'FAISS', color: '#00B894', icon: <FaCogs />, disabled: false },
  { type: 'vector', label: 'Annoy', color: '#E17055', icon: <FaSitemap />, disabled: false },
  { type: 'vector', label: 'Redis (Vector)', color: '#D63031', icon: <FaMemory />, disabled: false },
  { type: 'vector', label: 'Elasticsearch', color: '#005571', icon: <FaSearch />, disabled: false },
  { type: 'vector', label: 'OpenSearch', color: '#2D3436', icon: <FaSearchPlus />, disabled: false },

  { type: 'vector', label: 'LanceDB', color: '#0984E3', icon: <FaColumns />, disabled: false },
  { type: 'vector', label: 'Vespa', color: '#6AB04C', icon: <FaRocket />, disabled: false },
  { type: 'vector', label: 'PgVector', color: '#336791', icon: <FaDatabase />, disabled: false },
  { type: 'vector', label: 'Neo4j', color: '#00CEC9', icon: <FaProjectDiagram />, disabled: false },
  { type: 'vector', label: 'SingleStore', color: '#9B59B6', icon: <FaServer />, disabled: false },
]

function dispatchAddToolToWorkflow(handlerName, agentNodeId = null, toolType = 'tool', toolData = null) {
  const event = new CustomEvent('add-tool-to-workflow', { 
    detail: { handlerName, agentNodeId, toolType, toolData } 
  });
  window.dispatchEvent(event);
}

function dispatchAddLLMToWorkflow(llmType, model, agentNodeId = null, llmData = null, extra = {}) {
  const event = new CustomEvent('add-llm-to-workflow', { 
    detail: { llmType, model, agentNodeId, llmData, ...extra } 
  });
  window.dispatchEvent(event);
}

const CUSTOM_LLM_COLOR = '#5b6b7c';

const getCustomLlmIcon = (size = 20) => (
  <img src={customLlmIcon} alt="Custom LLM" width={size} height={size} style={{ objectFit: 'contain', display: 'block' }} />
);

const getCustomLlmNode = () => ({
  llmType: 'custom',
  displayName: 'Custom LLM',
  icon: getCustomLlmIcon(20),
  color: CUSTOM_LLM_COLOR,
  iconColor: CUSTOM_LLM_COLOR,
  llmModels: [],
  isCustom: true,
});

// Export these variables for use in other components
export let toolNodes = [];
export let llmNodes = [];
export let mcpToolNodes = [];

// Function to update the exported variables
const updateExportedData = (tools, llms, mcpTools) => {
  toolNodes = tools;
  llmNodes = llms;
  mcpToolNodes = mcpTools;
};

const COLOR_PALETTE_BASE = [
  '#FF33C4', '#33B5FF', '#198754', '#5b25e8', '#FFC300',
  '#8D33FF', '#FF8C33', '#029108', '#FF3333', '#19c663',
  '#FFB533', '#3357FF', '#B533FF', '#198754', '#FF3380',
  '#994C00', '#3380FF', '#FF8333', '#00CCCC', '#FF5733'
];

// Collapsible Section Component
const CollapsibleSection = ({ title, icon, isOpen, onToggle, children, color = '#4880FF' }) => {
  return (
    <div className="collapsible-section" title="">
      <div
        onClick={onToggle}
        className={`collapsible-section-header ${isOpen ? 'open' : ''}`}
        style={{ '--section-color': color }}
      >
        <div className="collapsible-section-header-content">
          <span className="collapsible-section-icon" style={{ color: color }} title="">{icon}</span>
          <span className="collapsible-section-title">
            {title}
          </span>
        </div>
        <span className={`collapsible-section-arrow ${isOpen ? 'open' : ''}`} style={{ color: color }} title="">
          <FaChevronDown />
        </span>
      </div>
      <div className={`collapsible-section-content ${isOpen ? 'open' : ''}`}>
        {children}
      </div>
    </div>
  );
};

const NodePalette = () => {

  const debounceRef = useRef(null);
  const [toolNodesState , setToolNodes] = useState([]);
  const [mcpToolNodesState, setMcpToolNodes] = useState([]);
  const [llmModels, setLLMModels] = useState([]);
  const [llmNodesState, setLLMNodes] = useState([]);
  const [showCombinedToolModal, setShowCombinedToolModal] = useState(false);
  const [activeTab, setActiveTab] = useState('tools'); // 'tools' or 'mcp'
  const [toolSearch, setToolSearch] = useState('');
  const [mcpToolSearch, setMcpToolSearch] = useState('');
  const [selectedTool, setSelectedTool] = useState(toolNodes[0]);
  const [selectedMcpTool, setSelectedMcpTool] = useState(mcpToolNodes[0]);
  const [showAgentAppsModal, setShowAgentAppsModal] = useState(false);
  
  // Pagination state for MCP tools
  const [mcpCurrentPage, setMcpCurrentPage] = useState(0);
  const [mcpLoading, setMcpLoading] = useState(false);
  const [mcpHasMore, setMcpHasMore] = useState(true);
  const [mcpTotalToolsCount, setMcpTotalToolsCount] = useState(0); // Total count of all tools
  const [mcpCountLoading, setMcpCountLoading] = useState(true); // Loading state for count calculation
  
  // Filtered tools for modal search
  const filteredTools = toolNodesState.filter(tool => 
    tool.displayName.toLowerCase().includes(toolSearch.toLowerCase())
  );
  
  // Handle tool search change
  const handleToolSearchChange = (e) => {
    setToolSearch(e.target.value);
  };  
  
  const handleMcpToolSearchChange = (e) => {
    const value = e.target.value;
    setMcpToolSearch(value);
    setMcpCurrentPage(0);
    clearTimeout(debounceRef.current);
  
    debounceRef.current = setTimeout(() => {
      if (!value.trim()) {
        setMcpToolNodes([]);
        getMCPTools(null, false); // default call when input empty
      } else {
        getMCPTools({ displayName: value }, false);
      }
    }, 400);
  };

  // Toggle method expansion
  const toggleMethodExpansion = (methodKey) => {
    setExpandedMethods(prev => {
      const newSet = new Set(prev);
      if (newSet.has(methodKey)) {
        newSet.delete(methodKey);
      } else {
        newSet.add(methodKey);
      }
      return newSet;
    });
  };  


  const [llmSearch, setLLMSearch] = useState('');
  const [showLLMModal, setShowLLMModal] = useState(false);
  const [selectedLLM, setSelectedLLM] = useState(llmNodes[0]);
  const [selectedModel, setSelectedModel] = useState('');
  const [customBaseUrl, setCustomBaseUrl] = useState('');
  const [copied, setCopied] = useState(false);
  const [interactionMode, setInteractionMode] = useState('DRAG');
  const [globalSearch, setGlobalSearch] = useState('');
  const [agentNodeId, setAgentNodeId] = useState(null); // Store agent node ID when modal is opened from AgentNode
  const [expandedMethods, setExpandedMethods] = useState(new Set()); // Track expanded method indices
  const [vectorStoreSearch, setVectorStoreSearch] = useState('');
  const [showVectorStoreModal, setShowVectorStoreModal] = useState(false);
  const [selectedVectorStore, setSelectedVectorStore] = useState(vectorStoreTypes[0]);
  
  // Category collapse states
  const [collapsedCategories, setCollapsedCategories] = useState({
    inputOutput: true,
    agents: true,
    tools: true,
    mcpTools: true,
    llms: true,
    vectorStore: true, // Start collapsed since not implemented
    embedding: true,    // Start collapsed since not implemented
    agentApps: true     // Start collapsed
  });

  const toggleCategory = (category) => {
    setCollapsedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  // Search functionality
  const filteredIoTypes = ioTypes.filter(node => 
    node.label.toLowerCase().includes(globalSearch.toLowerCase())
  );

  const filteredAgentTypes = agentTypes.filter(agent => 
    agent.label.toLowerCase().includes(globalSearch.toLowerCase())
  );

  const filteredToolNodes = toolNodesState.filter(tool => 
    tool.displayName.toLowerCase().includes(globalSearch.toLowerCase())
  );

  const filteredMcpToolNodes = mcpToolNodesState.filter(tool => 
    tool.displayName.toLowerCase().includes(globalSearch.toLowerCase())
  );

  const filteredLlmNodes = llmNodesState.filter(llm => 
    llm.displayName.toLowerCase().includes(globalSearch.toLowerCase())
  );

  const filteredVectorStoreTypes = vectorStoreTypes.filter(vectorStore => 
    vectorStore.label.toLowerCase().includes(globalSearch.toLowerCase())
  );

  // Filtered vector stores for modal
  const filteredVectorStoresForModal = vectorStoreTypes.filter(vectorStore => 
    vectorStore.label.toLowerCase().includes(vectorStoreSearch.toLowerCase())
  );

  // Auto-expand categories that have search results
  const autoExpandCategories = () => {
    const newCollapsedState = { ...collapsedCategories };
    
    if (filteredIoTypes.length > 0) newCollapsedState.inputOutput = false ;
    if (filteredAgentTypes.length > 0) newCollapsedState.agents = false;
    if (filteredToolNodes.length > 0) newCollapsedState.tools = false;
    if (filteredLlmNodes.length > 0) newCollapsedState.llms = false;
    if (filteredMcpToolNodes.length > 0) newCollapsedState.mcpTools = false;
    if (filteredVectorStoreTypes.length > 0) newCollapsedState.vectorStore = false;
    
    setCollapsedCategories(newCollapsedState);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    const searchTerm = e.target.value;
    setGlobalSearch(searchTerm);
    
    if (searchTerm.length > 0) {
      autoExpandCategories();
    }
  };

  // Highlight search term in text
  const highlightSearchTerm = (text, searchTerm) => {
    if (!searchTerm) return text;
    
    const regex = new RegExp(`(${searchTerm})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => 
      regex.test(part) ? (
        <span key={index} className="search-highlight">
          {part}
        </span>
      ) : part
    );
  };

  useEffect(() => {
    getTools();
    getLLMs();
    getMCPTools(null, false);
  },[])

  // Listen for tool modal open events from AgentNode
  useEffect(() => {
    const handleOpenToolModal = (event) => {
      setShowCombinedToolModal(true);
      setActiveTab('tools');
      setSelectedTool(toolNodesState[0] || null);
      setAgentNodeId(event.detail.agentNodeId); // Store agent node ID
    };

    const handleOpenLLMModal = (event) => {
      setShowLLMModal(true);
      setSelectedLLM(llmNodesState[0] || null);
      setSelectedModel('');
      setCustomBaseUrl('');
      setAgentNodeId(event.detail?.agentNodeId); // Store agent node ID
    };

    const handleOpenAgentAppsModal = () => {
      setShowAgentAppsModal(true);
    };

    window.addEventListener('open-tool-modal', handleOpenToolModal);
    window.addEventListener('open-llm-modal', handleOpenLLMModal);
    window.addEventListener('open-agent-apps-modal', handleOpenAgentAppsModal);

    return () => {
      window.removeEventListener('open-tool-modal', handleOpenToolModal);
      window.removeEventListener('open-llm-modal', handleOpenLLMModal);
      window.removeEventListener('open-agent-apps-modal', handleOpenAgentAppsModal);
    };
  }, [toolNodesState, llmNodesState]);

  const getTools = () => {
    UtilService.getHandlers().then((response) => {
      // Assign a color and iconColor from the palette to each tool
      const toolsWithColors = response.map((tool, idx) => {
        const color = COLOR_PALETTE_BASE[idx % COLOR_PALETTE_BASE.length];
        return {
          ...tool,
          color,
          iconColor: color,
        };
      });
     
      setToolNodes(toolsWithColors);
    });
  }

    const getMCPTools = (data, append) => {
    setMcpLoading(true);
    WorkflowService.getMCPTools(mcpCurrentPage, data).then((response) => {
      let mcpTools = response?.mcpDTOPage?.content;
      const toolsWithColors = mcpTools.map((tool, idx) => {
        const color = COLOR_PALETTE_BASE[idx % COLOR_PALETTE_BASE.length];
        return {
          ...tool,
          color,
          iconColor: color,
          methods: tool.methods
        };
      });


      if (append) {
        setMcpToolNodes(prev => [...prev, ...toolsWithColors]);
      } else {
        setMcpToolNodes(toolsWithColors);
      }
      if (!data || (!data.displayName && !data.key)) {
        setMcpTotalToolsCount(response?.mcpDTOPage?.totalElements);
      }
      setMcpHasMore(response?.mcpDTOPage?.totalPages > mcpCurrentPage + 1);
      setMcpLoading(false);
      setMcpCountLoading(false);
    }).finally(() => {
      setMcpLoading(false);
      setMcpCountLoading(false);
    });
  }

  const loadMoreMcpTools = () => {
    if (!mcpLoading && mcpHasMore) {
      setMcpCurrentPage(prev => prev + 1);
    }
  };

  React.useEffect(() => {
    if (mcpCurrentPage === 0) return; // skip first render
  
    if (mcpToolSearch.length > 0) {
      getMCPTools({ key: mcpToolSearch }, true);
    } else {
      getMCPTools(null, true);
    }
  }, [mcpCurrentPage]);


  const getLLMs = () => {
    const customLlmNode = getCustomLlmNode();

    UtilService.getLLMList().then(async (llms) => {
  
      const iconMap = {
        default: { icon: <img src={logo_icon} width={20} height={16} />, color: '#1976d2' },
        openai: { icon: <BsOpenai />, color: '#10a37f' },
        bedrock: { icon: <FaBrain />, color: '#1976d2' },
        ollama: { icon: <SiOllama />, color: '#a259e6' },
        gemini: { icon: <SiGooglegemini />, color: '#1976d2' },
        'azure-openai': { icon: <VscAzure />, color: '#4880FF' },
        'litellm': { icon: <img src={litellmIcon} width={30} alt="" />, color: '#1976d2' },
        custom: { icon: getCustomLlmIcon(20), color: CUSTOM_LLM_COLOR },
      };
  
      const llmarray = {};
      const providerList = Array.isArray(llms) ? llms : [];

      for (const llm of providerList) {
        if (isCustomLlmType(llm.name)) continue;
        const response = await UtilService.getModelsByLLm(llm.name);
      
        llmarray[llm.name] = response.map(modelName => ({
          displayName: `${llm.displayName}-${modelName.name}`,
          name: modelName.name,
          type: llm.name
        }));
      }
  
      setLLMModels(llmarray);
  
      const llmNodesArray = providerList
        .filter((l) => !isCustomLlmType(l.name))
        .map(l => {
          const iconDetails = iconMap[l.name] || {};
          return {
            llmType: l.name,
            displayName: l.displayName,
            icon: iconDetails.icon,
            color: iconDetails.color,
            iconColor: iconDetails.color,
            llmModels: llmarray[l.name] || []
          };
        });
      setLLMNodes([...llmNodesArray, customLlmNode]);
    }).catch(() => {
      setLLMNodes([customLlmNode]);
    });
  };
  

  const onDragStart = (event, nodeType, nodeData) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.setData('nodeData', JSON.stringify(nodeData));
    event.dataTransfer.effectAllowed = 'move';
  };

  // Filtered tools for modal or LLM search
  const filteredLLMs = llmNodesState?.filter((l) => {
    const q = (llmSearch || '').toLowerCase().trim();
    if (!q) return true;
    const providerMatch = (l?.displayName || '').toLowerCase().includes(q) || (l?.llmType || '').toLowerCase().includes(q);
    const modelMatch = Array.isArray(l?.llmModels) ? l.llmModels.some((m) => (m?.name || '').toLowerCase().includes(q)) : false;
    return providerMatch || modelMatch;
  });

  const filteredSelectedModels = React.useMemo(() => {
    if (!selectedLLM?.llmModels) return [];
    const q = (llmSearch || '').toLowerCase().trim();
    if (!q) return selectedLLM.llmModels;
    const providerMatch =
      (selectedLLM?.displayName || '').toLowerCase().includes(q) || (selectedLLM?.llmType || '').toLowerCase().includes(q);
    if (providerMatch) return selectedLLM.llmModels;
    return selectedLLM.llmModels.filter((m) => (m?.name || '').toLowerCase().includes(q));
  }, [llmSearch, selectedLLM]);

  React.useEffect(() => {
    if (!filteredTools.includes(selectedTool)) {
      setSelectedTool(filteredTools[0] || null);
    }
  }, [toolSearch]);

  React.useEffect(() => {
    if (!selectedMcpTool && mcpToolNodesState.length > 0) {
      setSelectedMcpTool(mcpToolNodesState[0]);
    }
  }, [mcpToolNodesState]);

  // Reset expanded methods when tool selection changes
  React.useEffect(() => {
    setExpandedMethods(new Set());
  }, [selectedTool]);

  React.useEffect(() => {
    if (!filteredLLMs.includes(selectedLLM)) {
      setSelectedLLM(filteredLLMs[0] || null);
      setSelectedModel('');
      setCustomBaseUrl('');
    }
  }, [llmSearch]);

  // Ensure selectedVectorStore is always in filteredVectorStoresForModal
  React.useEffect(() => {
    if (!filteredVectorStoresForModal.includes(selectedVectorStore)) {
      setSelectedVectorStore(filteredVectorStoresForModal[0] || null);
    }
  }, [vectorStoreSearch]);

  // Ensure selectedMcpTool is always in filteredMcpToolsForModal

  // Handle tab switching - reset search and selection when switching tabs

  // Format large numbers with K notation
  const formatCount = (count) => {
    if (count >= 1000) {
      return Math.round(count / 1000) + 'K';
    }
    return count.toString();
  };

  // Reset pagination when modal is closed
  const resetMcpPagination = () => {
    setMcpCurrentPage(0);
    setMcpHasMore(true);
    setMcpToolNodes([]);
    getMCPTools(null, false);
  };

  // Copy code to clipboard handler
  const handleCopyCode = (code) => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  useEffect(() => {
    updateExportedData(toolNodesState, llmNodesState, mcpToolNodesState);
  }, [toolNodesState, llmNodesState, mcpToolNodesState]);

  return (
    <div>
      <div className="node-palette-container palette-scrollbar">
        <div className="node-palette p-1">
          {/* Header */}
          <div className="node-palette-header">
            <div className="node-palette-title">
              <MdGridView className="node-palette-title-icon" />
              Category
            </div>
          </div>

          {/* Search Section */}
          <div className="node-palette-search-section">
            <div className="node-palette-search-container">
              <input
                className="form-control font14 node-palette-search-input"
                placeholder="Search Category..."
                value={globalSearch}
                onChange={handleSearchChange}
              />
              {/* <i className="fa-solid fa-search node-palette-search-icon pr-2" /> */}
              {globalSearch && (
                <button
                  onClick={() => setGlobalSearch('')}
                  className="node-palette-clear-search"
                  title="Clear search"
                >
                  ×
                </button>
              )}
            </div>
            {globalSearch && (
              <div className="node-palette-search-info">
                <i className="fa-solid fa-info-circle node-palette-search-info-icon"></i>
                Found {filteredIoTypes.length + filteredAgentTypes.length + filteredToolNodes.length + filteredLlmNodes.length + filteredVectorStoreTypes.length} results
              </div>
            )}
          </div>

          {/* Agents Section */}
          <CollapsibleSection
            title="Agents"
            icon={<FaRobot />}
            color="#8D33FF"
            isOpen={!collapsedCategories.agents}
            onToggle={() => toggleCategory('agents')}
          >
            {filteredAgentTypes?.map((agent, idx) => (
              <div
                key={agent.type + idx}
                className={`palette-node ${agent.disabled ? "palette-node-disabled" : ""}`}
                draggable={interactionMode === 'DRAG'}
                onDragStart={interactionMode === 'DRAG' ? e => {
                  onDragStart(e, 'agent', { agentType: agent.type, label: agent.label });
                } : undefined}
                onClick={interactionMode === 'CLICK' ? () => {
                  window.dispatchEvent(new CustomEvent('add-agent-to-workflow', { detail: { agentType: agent.type, label: agent.label } }));
                } : undefined}
              >
                <span className="palette-node-icon" style={{ color: agent.color }}>{agent.icon}</span>
                <span className="palette-node-text-ellipsis ms-2 font14">{highlightSearchTerm(agent.label, globalSearch)}</span>
              </div>
            ))}
            {globalSearch && filteredAgentTypes.length === 0 && (
              <div className="palette-no-results">
                No Agent nodes found
              </div>
            )}
          </CollapsibleSection>

          {/* Tools Section */}
          <CollapsibleSection
            title={<span>Tools <span className="badge bg-primary ms-2">{toolNodesState?.length}</span></span>}
            icon={<FaNetworkWired />}
            color="#FF8C33"
            isOpen={!collapsedCategories.tools}
            onToggle={() => toggleCategory('tools')}
          >
            {/* Show filtered tools or first 3 tools */}
            {(globalSearch ? filteredToolNodes : toolNodesState?.slice(0, 3)).map((t, idx) => (
              <div
                key={t.handlerName}
                className="palette-node"
                draggable={interactionMode === 'DRAG'}
                onDragStart={interactionMode === 'DRAG' ? e => onDragStart(e, 'config', { 
                  configType: 'tool', 
                  attributes: t.attributes,
                  handlerName: t.handlerName, 
                  displayName: t.displayName, 
                  icon: t.icon,
                  iconColor: t?.iconColor,
                  color: t?.color
                }) : undefined}
                onClick={interactionMode === 'CLICK' ? () => dispatchAddToolToWorkflow(t.handlerName) : undefined}
              >
                <span className="palette-node-icon" style={{ color: t.iconColor }}>
                  <ToolIcon tool={t} />
                </span>
                <span className="palette-node-text-ellipsis ms-1 font14">{highlightSearchTerm(t.displayName, globalSearch)}</span>
              </div>
            ))}
            {!globalSearch && toolNodesState?.length > 3 && (
              <div className='my-1 w-100 text-center'>
                <button 
                  className="btn btn-link palette-show-more-btn" 
                  onClick={() => {
                    setShowCombinedToolModal(true);
                    setActiveTab('tools');
                    setSelectedTool(toolNodesState[0] || null);
                  }}
                >
                  Show More <i className="fa-solid fa-arrow-right ms-2"></i>
                </button>
              </div>
            )}
            {globalSearch && filteredToolNodes.length === 0 && (
              <div className="palette-no-results">
                No Tool nodes found
              </div>
            )}
          </CollapsibleSection>

          {/* MCP Gateway section */}
          <CollapsibleSection
            title={<span>MCP Gateway <span className="badge bg-primary ms-2">
              {mcpCountLoading ? (
                <i className="fa-solid fa-spinner fa-spin"></i>
              ) : (
                formatCount(mcpTotalToolsCount)
              )}
            </span>
            </span>}
            icon={<img src={mcpIcon} alt="MCP Gateway" width={20} height={20} className="palette-node-icon" />}
            color="#FF8C33"
            isOpen={!collapsedCategories.mcpTools}
            onToggle={() => toggleCategory('mcpTools')}
          >
            {/* Show filtered tools or first 3 tools */}
            {(globalSearch ? filteredMcpToolNodes : mcpToolNodesState?.slice(0, 3)).map((t, idx ) => (
              <div
                key={t.handlerName + idx}
                className="palette-node"
                draggable={interactionMode === 'DRAG'}
                onDragStart={interactionMode === 'DRAG' ? e => onDragStart(e, 'config', { 
                  configType: 'tool', 
                  key: t.key,
                  attributes: t.attributes,
                  handlerName: t.handlerName, 
                  displayName: t.displayName, 
                  icon: t.icon,
                  srcPath: t.srcPath,
                  dependencies: t?.dependencies,
                  iconColor: t?.iconColor,
                  color: t?.color
                }) : undefined}
              >
                <span className="palette-node-icon" style={{ color: t.iconColor }}>
                  <ToolIcon tool={t} />
                </span>
                <span className="palette-node-text-ellipsis ms-1 font14">{highlightSearchTerm(t.displayName, globalSearch)}</span>
              </div>
            ))}
            {!globalSearch && (
              <div className='my-1 w-100 text-center'>
                {mcpToolNodesState?.length > 3 && (
                  <button 
                    className="btn btn-link palette-show-more-btn me-2" 
                    onClick={() => {
                      setShowCombinedToolModal(true);
                      setActiveTab('mcp');
                      setSelectedMcpTool(mcpToolNodesState[0] || null);
                    }}
                  >
                    Show More <i className="fa-solid fa-arrow-right ms-2"></i>
                  </button>
                )}
              </div>
            )}
            {globalSearch && filteredMcpToolNodes.length === 0 && (
              <div className="palette-no-results">
                No Tool nodes found
              </div>
            )}
          </CollapsibleSection>

          {/* LLMs Section */}
          <CollapsibleSection
            title="LLMs"
            icon={<FaBrain />}
            color="#1976d2"
            isOpen={!collapsedCategories.llms}
            onToggle={() => toggleCategory('llms')}
          >
            {(globalSearch
              ? filteredLlmNodes
              : [
                  ...(llmNodesState || []).filter((l) => !isCustomLlmType(l.llmType)).slice(0, 3),
                  ...(llmNodesState || []).filter((l) => isCustomLlmType(l.llmType)),
                ]
            ).map((l, idx ) => (
              <div
                key={l.llmType + idx}
                className="palette-node"
                draggable={interactionMode === 'DRAG'}
                onDragStart={interactionMode === 'DRAG' ? e => onDragStart(e, 'config', { configType: 'llm', llmType: l.llmType, llmModels: l.llmModels, displayName: l.displayName, iconColor: l.color }) : undefined}
                onClick={interactionMode === 'CLICK' ? () => {
                  setShowLLMModal(true);
                  setSelectedLLM(l);
                  setSelectedModel('');
                  setCustomBaseUrl('');
                  setAgentNodeId(null);
                } : undefined}
              >
                <span className="palette-node-icon" style={{ color: l.iconColor, fontSize: 16 }}>{l.icon}</span>
                <span className="palette-node-text ms-2">{highlightSearchTerm(l.displayName, globalSearch)}</span>
              </div>
            ))}
            {!globalSearch && (
              <div className='my-1 w-100 text-center'>
                {filteredLlmNodes?.length > 3 && (
                  <button 
                    className="btn btn-link palette-show-more-btn me-2" 
                    onClick={() => {
                      setShowLLMModal(true);
                      setActiveTab('llms');
                      setSelectedLLM(llmNodesState[0] || null);
                      setSelectedModel('');
                      setCustomBaseUrl('');
                    }}
                  >
                    Show More <i className="fa-solid fa-arrow-right ms-2"></i>
                  </button>
                )}
              </div>
            )}
            {globalSearch && filteredLlmNodes.length === 0 && (
              <div className="palette-no-results">
                No LLM nodes found
              </div>
            )}
          </CollapsibleSection>

          {/* Vector Store Section */}
          <CollapsibleSection
            title="Vector Store"
            icon={<FaFileAlt />}
            color="#6c757d"
            isOpen={!collapsedCategories.vectorStore}
            onToggle={() => toggleCategory('vectorStore')}
          >
            {(globalSearch ? filteredVectorStoreTypes : vectorStoreTypes.slice(0, 3)).map((vectorStore, idx) => (
              <div
                key={vectorStore.type + idx}
                className={`palette-node ${vectorStore.disabled ? "palette-node-disabled" : ""}`}
              >
                <span className="palette-node-icon" style={{ color: vectorStore.color }}>
                  <span className="tool-modal-tool-icon" style={{ color: vectorStore.color, fontSize: 16 }}>
                    <span
                      className="tool-modal-tool-icon"
                      style={{ color: vectorStore.color, fontSize: 16 }}
                    >
                      {vectorStore.label?.charAt(0).toUpperCase()}
                    </span>
                  </span>
                </span>
                <span className="palette-node-text-ellipsis font14">{highlightSearchTerm(vectorStore.label, globalSearch)}</span>
              </div>
            ))}
            {!globalSearch && vectorStoreTypes.length > 3 && (
              <div className='my-1 w-100 text-center'>
                <button 
                  className="btn btn-link palette-show-more-btn" 
                  onClick={() => {
                    setShowVectorStoreModal(true);
                    setSelectedVectorStore(vectorStoreTypes[0] || null);
                  }}
                >
                  Show More <i className="fa-solid fa-arrow-right ms-2"></i>
                </button>
              </div>
            )}
            {globalSearch && filteredVectorStoreTypes.length === 0 && (
              <div className="palette-no-results">
                No Vector Store nodes found
              </div>
            )}
          </CollapsibleSection>

          {/* Embedding Section */}
          <CollapsibleSection
            title="Embedding"
            icon={<FaBrain />}
            color="#6c757d"
            isOpen={!collapsedCategories.embedding}
            onToggle={() => toggleCategory('embedding')}
          >
            <div className="palette-coming-soon">
              <i className="fa-solid fa-clock palette-coming-soon-icon"></i>
              Coming soon
            </div>
          </CollapsibleSection>

          {/* Agent Apps Section */}
          <CollapsibleSection
            title="Agent Apps"
            icon={<FaAppStore />}
            color="#8D33FF"
            isOpen={false}
            onToggle={() => setShowAgentAppsModal(true)}
          >
            <div className="palette-coming-soon" style={{ cursor: 'pointer' }} onClick={() => setShowAgentAppsModal(true)}>
              <i className="fa-solid fa-external-link-alt palette-coming-soon-icon"></i>
              Click to open Agent Apps
            </div>
          </CollapsibleSection>

          {/* No results message */}
          {globalSearch && 
           filteredIoTypes.length === 0 && 
           filteredAgentTypes.length === 0 && 
           filteredToolNodes.length === 0 && 
           filteredLlmNodes.length === 0 && 
           filteredVectorStoreTypes.length === 0 && (
            <div className="palette-no-results-global">
              <i className="fa-solid fa-search palette-no-results-global-icon"></i>
              <div className="palette-no-results-global-title">No nodes found</div>
              <div className="palette-no-results-global-subtitle">Try adjusting your search terms</div>
            </div>
          )}

          {/* Combined Modal for Tools and MCP Tools with tabs */}
          {showCombinedToolModal && (
            <div className="tool-modal-overlay" onClick={() => {
              setShowCombinedToolModal(false);
              setAgentNodeId(null);
              setToolSearch('');
              setMcpToolSearch('');
              resetMcpPagination();
            }}>
              <div className="tool-modal-container" onClick={e => e.stopPropagation()}>
                {/* Modal header */}
                <div className="tool-modal-header">
                  <div className="tool-modal-title">
                    <div style={{ fontWeight: 700, fontSize: 18 }}>Select a Tool</div>
                  </div>
                  <button onClick={() => {
                    setShowCombinedToolModal(false);
                    setAgentNodeId(null);
                    setToolSearch('');
                    setMcpToolSearch('');
                    resetMcpPagination();
                  }} className="tool-modal-close">&times;</button>
                </div>

                {/* Tab Navigation */}
                <div className="tool-modal-tabs">
                  <button
                    className={`tool-modal-tab ${activeTab === 'tools' ? 'active' : ''}`}
                    onClick={() => setActiveTab('tools')}
                  >
                    <i className="fas fa-tools me-2"></i>
                    Tools
                  </button>
                  <button
                    className={`tool-modal-tab ${activeTab === 'mcp' ? 'active' : ''}`}
                    onClick={() => setActiveTab('mcp')}
                  >
                    <i className="fas fa-plug me-2"></i>
                    MCP Gateway
                  </button>
                </div>

                {/* Modal content: two columns */}
                <div className="tool-modal-content">
                  {/* Left: tool list with search */}
                  <div className="tool-modal-sidebar">
                    <div className="tool-modal-search">
                      <input
                        className="form-control font14 tool-modal-search-input"
                        placeholder={`Search ${activeTab === 'tools' ? 'tool' : 'MCP Gateway'}...`}
                        value={activeTab === 'tools' ? toolSearch : mcpToolSearch}
                        onChange={activeTab === 'tools' ? handleToolSearchChange : handleMcpToolSearchChange}
                      />
                    </div>
                    <div className="tool-modal-tool-list">
                      {activeTab === 'tools' ? (
                        // Tools Tab Content
                        <>
                          {filteredTools.length === 0 && <div className="text-muted text-center py-3">No tools found</div>}
                          {filteredTools.map((t, idx) => (
                            <div
                              key={t.handlerName + idx}
                              className={`tool-modal-tool-item ${selectedTool && selectedTool.handlerName === t.handlerName ? 'selected' : ''}`}
                              onClick={() => setSelectedTool(t)}
                              style={{ '--tool-color': t.color }}
                            >
                              <span className="tool-modal-tool-icon" style={{ color: t.iconColor }}>
                                <ToolIcon tool={t} />
                              </span>
                              <span className="tool-modal-tool-name">{t.displayName}</span>
                            </div>
                          ))}
                        </>
                      ) : (
                        // MCP Gateway Tab Content
                        <>
                          {mcpToolNodesState?.length === 0 && <div className="text-muted text-center py-3">No MCP Gateway found</div>}
                          {mcpToolNodesState?.map((t, idx) => (
                            <div
                              key={t.handlerName + idx}
                              className={`tool-modal-tool-item ${selectedMcpTool && selectedMcpTool?.key === t?.key ? 'selected' : ''}`}
                              onClick={() => setSelectedMcpTool(t)}
                              style={{ '--tool-color': t.color }}
                            >
                              <span className="tool-modal-tool-icon" style={{ color: t.iconColor }}>
                                <ToolIcon tool={t} />
                              </span>
                              <span className="tool-modal-tool-name text-ellipsis">{t.displayName}</span>
                            </div>
                          ))}
                          {mcpHasMore && (
                            <div className="text-center py-3">
                              <button 
                                className="btn btn-outline-primary btn-sm" 
                                onClick={loadMoreMcpTools}
                                disabled={mcpLoading}
                              >
                                {mcpLoading ? (
                                  <>
                                    <i className="fa-solid fa-spinner fa-spin me-2"></i>
                                    Loading...
                                  </>
                                ) : (
                                  <>
                                   <i className="fa-solid fa-plus ms-2"></i> &nbsp; Load More Tools 
                                  </>
                                )}
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>

                  {/* Right: preview panel with handler details and extended info */}
                  <div className="tool-modal-preview">
                    {activeTab === 'tools' ? (
                      // Tools Preview
                      selectedTool ? (
                        <div className="tool-modal-preview-content">
                          <div className="tool-modal-preview-icon space-between" style={{ color: selectedTool.iconColor }}>
                            <ToolIcon tool={selectedTool} />
                            <button
                              className="btn btn-success btn-sm tool-modal-add-btn"
                              onClick={() => {
                                dispatchAddToolToWorkflow(selectedTool.handlerName, agentNodeId, 'tool', selectedTool);
                                setShowCombinedToolModal(false);
                                setAgentNodeId(agentNodeId);
                              }}
                            >
                              Enable
                            </button>
                          </div>
                          <div className="tool-modal-preview-header space-between">
                            <div className="tool-modal-preview-title">{selectedTool.displayName}</div>
                          </div>
                          <div className='tool-modal-description' style={{
                            lineHeight: '1.6',
                            marginBottom: selectedTool?.description && selectedTool?.description.length > 0 ? '12px' : '0',
                            whiteSpace: 'pre-wrap'
                          }}>
                            {selectedTool?.description}
                          </div>
                          <>
                            {selectedTool?.longDescription && (
                              <div className="tool-modal-long-description">{selectedTool?.longDescription}</div>
                            )}
                            {selectedTool?.example && (
                              <div className="tool-modal-example-section">
                                <div className="tool-modal-example-title">Example</div>
                                <div className="tool-modal-example-text">{selectedTool?.example}</div>
                              </div>
                            )}
                            {selectedTool?.methods && selectedTool.methods.length > 0 && (
                              <div className="tool-modal-methods-section" style={{
                                marginTop: '20px',
                                paddingTop: '20px',
                                borderTop: '1px solid #e0e0e0'
                              }}>
                                <div className="tool-modal-methods-title" style={{
                                  fontSize: '16px',
                                  fontWeight: 600,
                                  color: '#23272e',
                                  marginBottom: '16px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px'
                                }}>
                                  <span style={{ 
                                    width: '3px', 
                                    height: '16px', 
                                    backgroundColor: selectedTool?.iconColor || '#6c757d',
                                    borderRadius: '2px'
                                  }}></span>
                                  Methods
                                </div>
                                <div style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: '16px'
                                }}>
                                  {selectedTool.methods.map((method, methodIdx) => {
                                    const methodKey = `${selectedTool?.handlerName || 'tool'}-${methodIdx}`;
                                    const isExpanded = expandedMethods.has(methodKey);
                                    const hasParams = method.params && method.params.length > 0;
                                    
                                    return (
                                    <div 
                                      key={methodIdx}
                                      style={{
                                        background: '#f8f9fa',
                                        borderRadius: '8px',
                                        padding: '16px',
                                        border: '1px solid #e9ecef',
                                        transition: 'all 0.2s ease',
                                        cursor: hasParams ? 'pointer' : 'default'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.background = '#ffffff';
                                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                                        e.currentTarget.style.borderColor = selectedTool?.iconColor || '#6c757d';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.background = '#f8f9fa';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.borderColor = '#e9ecef';
                                      }}
                                      onClick={() => hasParams && toggleMethodExpansion(methodKey)}
                                    >
                                      {/* Method Name and Expand/Collapse Icon */}
                                      <div style={{
                                        fontSize: '15px',
                                        fontWeight: 600,
                                        color: '#23272e',
                                        marginBottom: '8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                      }}>
                                        <span style={{
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          width: '24px',
                                          height: '24px',
                                          borderRadius: '4px',
                                          backgroundColor: selectedTool?.iconColor || '#6c757d',
                                          color: '#fff',
                                          fontSize: '11px',
                                          fontWeight: 700
                                        }}>
                                          {String.fromCharCode(65 + methodIdx)}
                                        </span>
                                        <code style={{
                                          background: 'transparent',
                                          padding: '2px 6px',
                                          borderRadius: '4px',
                                          fontSize: '14px',
                                          fontFamily: 'Monaco, Menlo, "Ubuntu Mono", monospace',
                                          color: selectedTool?.iconColor || '#6c757d',
                                          fontWeight: 600
                                        }}>
                                          {method.name}
                                        </code>
                                        {hasParams && (
                                          <span style={{
                                            marginLeft: 'auto',
                                            display: 'flex',
                                            alignItems: 'center',
                                            color: selectedTool?.iconColor || '#6c757d',
                                            transition: 'transform 0.2s ease',
                                            transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'
                                          }}>
                                            <FaChevronRight size={12} />
                                          </span>
                                        )}
                                      </div>
                                      
                                      {/* Method Description */}
                                      {method.description && (
                                        <div style={{
                                          fontSize: '13px',
                                          color: '#495057',
                                          lineHeight: '1.6',
                                          marginBottom: hasParams && isExpanded ? '12px' : '0',
                                          whiteSpace: 'pre-wrap'
                                        }}>
                                          {method.description}
                                        </div>
                                      )}
                                      
                                      {/* Parameters - Only show when expanded */}
                                      {hasParams && isExpanded && (
                                        <div style={{
                                          marginTop: '12px',
                                          paddingTop: '12px',
                                          borderTop: '1px solid #dee2e6'
                                        }}>
                                          <div style={{
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            color: '#6c757d',
                                            marginBottom: '8px',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                          }}>
                                            Parameters
                                          </div>
                                          <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '8px'
                                          }}>
                                            {method.params.map((param, paramIdx) => (
                                              <div 
                                                key={paramIdx}
                                                style={{
                                                  display: 'flex',
                                                  alignItems: 'flex-start',
                                                  gap: '12px',
                                                  padding: '8px',
                                                  background: '#ffffff',
                                                  borderRadius: '6px',
                                                  border: '1px solid #e9ecef'
                                                }}
                                              >
                                                <div style={{
                                                  minWidth: '80px',
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  gap: '4px'
                                                }}>
                                                  <code style={{
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                    color: '#23272e',
                                                    fontFamily: 'Monaco, Menlo, "Ubuntu Mono", monospace'
                                                  }}>
                                                    {param.name}
                                                  </code>
                                                  <span style={{
                                                    fontSize: '11px',
                                                    color: '#6c757d',
                                                    fontStyle: 'italic'
                                                  }}>
                                                    {param.type}
                                                  </span>
                                                </div>
                                                <div style={{
                                                  flex: 1,
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  gap: '4px'
                                                }}>
                                                  <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    flexWrap: 'wrap'
                                                  }}>
                                                    {param.isOptional ? (
                                                      <span style={{
                                                        fontSize: '11px',
                                                        padding: '2px 6px',
                                                        borderRadius: '4px',
                                                        backgroundColor: '#fff3cd',
                                                        color: '#856404',
                                                        fontWeight: 500
                                                      }}>
                                                        Optional
                                                      </span>
                                                    ) : (
                                                      <span style={{
                                                        fontSize: '11px',
                                                        padding: '2px 6px',
                                                        borderRadius: '4px',
                                                        backgroundColor: '#f8d7da',
                                                        color: '#721c24',
                                                        fontWeight: 500
                                                      }}>
                                                        Required
                                                      </span>
                                                    )}
                                                    {param.default !== null && param.default !== undefined && (
                                                      <span style={{
                                                        fontSize: '11px',
                                                        color: '#6c757d'
                                                      }}>
                                                        Default: <code style={{
                                                          background: '#f8f9fa',
                                                          padding: '1px 4px',
                                                          borderRadius: '3px',
                                                          fontSize: '10px'
                                                        }}>{String(param.default)}</code>
                                                      </span>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                            {selectedTool?.link && (
                              <div className="tool-modal-example-section">
                                <a href={selectedTool?.link} target="_blank" rel="noopener noreferrer" className="tool-modal-doc-link">Documentation</a>
                              </div>
                            )}
                          </>
                        </div>
                      ) : (
                        <div className="tool-modal-no-selection">No tool selected</div>
                      )
                    ) : (
                      // MCP Gateway Preview
                      selectedMcpTool ? (
                        <div className="tool-modal-preview-content">
                          <div className="tool-modal-preview-icon space-between" style={{ color: selectedMcpTool.iconColor }}>
                            <ToolIcon tool={selectedMcpTool} />
                            <button
                              className="btn btn-success btn-sm tool-modal-add-btn"
                              onClick={() => {
                                dispatchAddToolToWorkflow(selectedMcpTool.key, agentNodeId, 'mcp', selectedMcpTool);
                                setShowCombinedToolModal(false);
                                setAgentNodeId(agentNodeId);
                              }}
                            >
                              Enable
                            </button>
                          </div>
                          <div className="tool-modal-preview-header space-between">
                            <div className="tool-modal-preview-title">{selectedMcpTool.displayName}</div>
                          </div>
                          <div className="tool-modal-description">{selectedMcpTool?.description}</div>
                          <>
                            {selectedMcpTool?.longDescription && (
                              <div className="tool-modal-long-description">{selectedMcpTool?.longDescription}</div>
                            )}
                            {selectedMcpTool?.example && (
                              <div className="tool-modal-example-section">
                                <div className="tool-modal-example-title">Example</div>
                                <div className="tool-modal-example-text">{selectedMcpTool?.example}</div>
                              </div>
                            )}
                            {selectedMcpTool?.codeSnippet && (
                              <div className="tool-modal-code-section">
                                <div className="tool-modal-code-title">Usage code snippet</div>
                                <div className="tool-modal-code-container">
                                  <pre className="tool-modal-code-block">
                                    <code>{selectedMcpTool?.codeSnippet}</code>
                                  </pre>
                                  <button
                                    onClick={() => handleCopyCode(selectedMcpTool?.codeSnippet)}
                                    className="tool-modal-copy-btn"
                                    title="Copy code"
                                  >
                                    <FaRegCopy style={{ marginRight: 3, color: '#23272e' }} />
                                    {copied ? <span className="tool-modal-copy-text">Copied!</span> : ''}
                                  </button>
                                </div>
                              </div>
                            )}
                          </>
                        </div>
                      ) : (
                        <div className="tool-modal-no-selection">No MCP Gateway selected</div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal for Agent Apps */}
          {showAgentAppsModal && (
            <div className="tool-modal-overlay" onClick={() => setShowAgentAppsModal(false)}>
              <div className="agent-apps-modal-container" onClick={e => e.stopPropagation()}>
                {/* Modal header */}
                <div className="tool-modal-header">
                  <div className="tool-modal-title">
                    <div style={{ fontWeight: 700, fontSize: 18 }}>Agent Apps</div>
                  </div>
                  <button onClick={() => setShowAgentAppsModal(false)} className="tool-modal-close">&times;</button>
                </div>
                {/* Modal content */}
                <div className="agent-apps-modal-content">
                  <AgentApps />
                </div>
              </div>
            </div>
          )}

          {/* Modal for all LLMs with search */}
          {showLLMModal && (
            <div className="tool-modal-overlay" onClick={() => {
              setShowLLMModal(false);
              setAgentNodeId(null);
              setSelectedModel('');
              setCustomBaseUrl('');
            }}>
              <div className="tool-modal-container" onClick={e => e.stopPropagation()}>
                {/* Modal header */}
                <div className="tool-modal-header">
                  <div className="tool-modal-title">
                    <div style={{ fontWeight: 700, fontSize: 18 }}>Select an LLM</div>
                  </div>
                  <button onClick={() => {
                    setShowLLMModal(false);
                    setAgentNodeId(null);
                    setSelectedModel('');
                    setCustomBaseUrl('');
                  }} className="tool-modal-close">&times;</button>
                </div>
                {/* Modal content: two columns */}
                <div className="tool-modal-content">
                  {/* Left: LLM list with search */}
                  <div className="tool-modal-sidebar">
                    <div className="tool-modal-search">
                      <input
                        className="form-control font14 tool-modal-search-input"
                        placeholder="Search LLM or Model"
                        value={llmSearch}
                        onChange={e => setLLMSearch(e.target.value)}
                      />
                    </div>
                    <div className="tool-modal-tool-list">
                      {filteredLLMs.length === 0 && <div className="text-muted text-center py-3">No LLMs found</div>}
                      {filteredLLMs.map((l, idx) => (
                        <div
                          key={l.llmType + idx}
                          className={`tool-modal-tool-item ${selectedLLM && selectedLLM.llmType === l.llmType ? 'selected' : ''}`}
                          onClick={() => {
                            setSelectedLLM(l);
                            setSelectedModel('');
                            setCustomBaseUrl('');
                          }}
                          style={{ '--tool-color': l.color }}
                        >
                          <span className="tool-modal-tool-icon" style={{ color: l.iconColor, fontSize: 16 }}>
                            {l.icon}
                          </span>
                          <span className="tool-modal-tool-name">{l.displayName}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* Right: preview panel with LLM details */}
                  <div className="tool-modal-preview">
                    {selectedLLM ? (() => {
                      const isCustomSelected = isCustomLlmType(selectedLLM.llmType);
                      const canEnableLlm = isCustomSelected
                        ? Boolean(selectedModel?.trim())
                        : Boolean(selectedModel);
                      return (
                      <div className="tool-modal-preview-content">
                        <div className="tool-modal-preview-icon space-between" style={{ color: selectedLLM.iconColor, fontSize: 30 }}>
                          {selectedLLM.icon}
                          <button
                            className="btn btn-success btn-sm tool-modal-add-btn"
                            disabled={!canEnableLlm}
                            onClick={() => {
                              dispatchAddLLMToWorkflow(
                                selectedLLM.llmType,
                                isCustomSelected ? selectedModel.trim() : selectedModel,
                                agentNodeId,
                                selectedLLM,
                                isCustomSelected ? { baseUrl: customBaseUrl.trim() } : {}
                              );
                              setShowLLMModal(false);
                              setAgentNodeId(null);
                              setSelectedModel('');
                              setCustomBaseUrl('');
                            }}
                            style={{
                              opacity: canEnableLlm ? 1 : 0.6,
                              cursor: canEnableLlm ? 'pointer' : 'not-allowed'
                            }}
                          >
                            Enable
                          </button>
                        </div>
                        <div className="tool-modal-preview-header space-between">
                          <div className="tool-modal-preview-title">{selectedLLM.displayName}</div>
                        </div>
                        {isCustomSelected ? (
                        <div className="tool-modal-example-section">
                          <div className="tool-modal-example-title">Configuration</div>
                          <div className="tool-modal-example-text" style={{ marginTop: 12 }}>
                            <div style={{ marginBottom: 16 }}>
                              <label className="font13 required" style={{ color: '#4a5568', marginBottom: 8, display: 'block' }}>
                                Model name
                              </label>
                              <input
                                type="text"
                                className="form-control font13"
                                placeholder="Enter model name"
                                value={selectedModel}
                                onChange={(e) => setSelectedModel(e.target.value)}
                              />
                            </div>
                            <div>
                              <label className="font13" style={{ color: '#4a5568', marginBottom: 8, display: 'block' }}>
                                Base URL <span style={{ color: '#94a3b8', fontWeight: 400 }}>(optional)</span>
                              </label>
                              <input
                                type="text"
                                className="form-control font13"
                                placeholder="Enter base URL"
                                value={customBaseUrl}
                                onChange={(e) => setCustomBaseUrl(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        ) : (
                        <div className="tool-modal-example-section">
                          <div className="tool-modal-example-title">Select Model</div>
                          <div className="tool-modal-example-text">
                            {filteredSelectedModels && filteredSelectedModels.length > 0 ? (
                              <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                gap: '12px',
                                marginTop: '8px'
                              }}>
                                {filteredSelectedModels.map((model, index) => (
                                  <div
                                    key={index}
                                    onClick={() => setSelectedModel(model.name)}
                                    style={{
                                      border: selectedModel === model.name ? '2px solid #0ea5e9' : '1px solid #e1e5e9',
                                      borderRadius: '12px',
                                      padding: '16px',
                                      background: selectedModel === model.name ? '#f0f9ff' : '#fff',
                                      cursor: 'pointer',
                                      transition: 'all 0.2s ease',
                                      position: 'relative',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '12px'
                                    }}
                                    onMouseEnter={(e) => {
                                      if (selectedModel !== model.name) {
                                        e.currentTarget.style.borderColor = '#0ea5e9';
                                        e.currentTarget.style.background = '#f8fafc';
                                      }
                                    }}
                                    onMouseLeave={(e) => {
                                      if (selectedModel !== model.name) {
                                        e.currentTarget.style.borderColor = '#e1e5e9';
                                        e.currentTarget.style.background = '#fff';
                                      }
                                    }}
                                  >
                                    {/* Radio Button */}
                                    <div style={{
                                      width: '20px',
                                      height: '20px',
                                      borderRadius: '50%',
                                      border: selectedModel === model.name ? '2px solid #0ea5e9' : '2px solid #cbd5e1',
                                      background: selectedModel === model.name ? '#0ea5e9' : '#fff',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      flexShrink: 0
                                    }}>
                                      {selectedModel === model.name && (
                                        <div style={{
                                          width: '8px',
                                          height: '8px',
                                          borderRadius: '50%',
                                          background: '#fff'
                                        }} />
                                      )}
                                    </div>
                                    
                                    {/* Model Info */}
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                      <div 
                                        title={model.name}
                                        style={{
                                          fontWeight: 600,
                                          fontSize: '14px',
                                          color: selectedModel === model.name ? '#0ea5e9' : '#1e293b',
                                          marginBottom: '2px',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap'
                                        }}>
                                        {model.name}
                                      </div>
                                      <div style={{
                                        fontSize: '12px',
                                        color: '#64748b'
                                      }}>
                                        Model {index + 1}
                                      </div>
                                    </div>
                                    
                                    {/* Check Icon */}
                                    {selectedModel === model.name && (
                                      <div style={{
                                        color: '#0ea5e9',
                                        fontSize: '16px'
                                      }}>
                                        <i className="fa-solid fa-check-circle" />
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div style={{
                                textAlign: 'center',
                                padding: '20px',
                                color: '#64748b',
                                fontSize: '14px'
                              }}>
                                <i className="fa-solid fa-exclamation-triangle" style={{ fontSize: '16px', marginBottom: '8px', display: 'block' }}></i>
                                No models available
                              </div>
                            )}
                          </div>
                        </div>
                        )}
                      </div>
                      );
                    })() : (
                      <div className="tool-modal-no-selection">No LLM selected</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal for Vector Stores */}
          {showVectorStoreModal && (
            <div className="tool-modal-overlay" onClick={() => {
              setShowVectorStoreModal(false);
              setVectorStoreSearch('');
            }}>
              <div className="tool-modal-container" onClick={e => e.stopPropagation()}>
                {/* Modal header */}
                <div className="tool-modal-header">
                  <div className="tool-modal-title">
                    <div style={{ fontWeight: 700, fontSize: 18 }}>Select a Vector Store</div>
                  </div>
                  <button onClick={() => {
                    setShowVectorStoreModal(false);
                    setVectorStoreSearch('');
                  }} className="tool-modal-close">&times;</button>
                </div>
                {/* Modal content: two columns */}
                <div className="tool-modal-content">
                  {/* Left: vector store list with search */}
                  <div className="tool-modal-sidebar">
                    <div className="tool-modal-search">
                      <input
                        className="form-control font14 tool-modal-search-input"
                        placeholder="Search Vector Store..."
                        value={vectorStoreSearch}
                        onChange={e => setVectorStoreSearch(e.target.value)}
                      />
                    </div>
                    <div className="tool-modal-tool-list">
                      {filteredVectorStoresForModal.length === 0 && <div className="text-muted text-center py-3">No Vector Stores found</div>}
                      {filteredVectorStoresForModal.map((vs, idx) => (
                        <div
                          key={vs.type + idx}
                          className={`tool-modal-tool-item ${selectedVectorStore && selectedVectorStore.label === vs.label ? 'selected' : ''}`}
                          onClick={() => setSelectedVectorStore(vs)}
                          style={{ '--tool-color': vs.color }}
                        >
                          <span className="tool-modal-tool-icon" style={{ color: vs.color, fontSize: 16 }}>
                            <span
                              className="tool-modal-tool-icon"
                              style={{ color: vs.color, fontSize: 16 }}
                            >
                              {vs.label?.charAt(0).toUpperCase()}
                            </span>
                          </span>
                          <span className="tool-modal-tool-name">{vs.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* Right: preview panel with vector store details */}
                  <div className="tool-modal-preview">
                    {selectedVectorStore ? (
                      <div className="tool-modal-preview-content">
                        <div className="tool-modal-preview-icon space-between force-disabled" style={{ color: selectedVectorStore.color, fontSize: 30 }}>
                          <span className="tool-modal-tool-icon" style={{ color: selectedVectorStore.color, fontSize: 16 }}>
                            <span
                              className="tool-modal-tool-icon"
                              style={{ color: selectedVectorStore.color, fontSize: 16 }}
                            >
                              {selectedVectorStore.label?.charAt(0).toUpperCase()}
                            </span>
                          </span>
                          <button
                            className="btn btn-success btn-sm tool-modal-add-btn"
                            disabled={selectedVectorStore.disabled}
                            onClick={() => {
                              window.dispatchEvent(new CustomEvent('add-vector-store-to-workflow', { 
                                detail: { vectorStoreType: selectedVectorStore.type, label: selectedVectorStore.label } 
                              }));
                              setShowVectorStoreModal(false);
                              setVectorStoreSearch('');
                            }}
                            style={{
                              opacity: selectedVectorStore.disabled ? 0.6 : 1,
                              cursor: selectedVectorStore.disabled ? 'not-allowed' : 'pointer'
                            }}
                          >
                            Enable
                          </button>
                        </div>
                        <div className="tool-modal-preview-header space-between">
                          <div className="tool-modal-preview-title">{selectedVectorStore.label}</div>
                        </div>
                        <div className="tool-modal-description">
                          {selectedVectorStore.disabled ? (
                            <div style={{ color: '#dc3545', fontSize: '14px' }}>
                              <i className="fa-solid fa-exclamation-triangle me-2"></i>
                              This vector store is currently disabled
                            </div>
                          ) : (
                            <div style={{ color: '#6c757d', fontSize: '14px' }}>
                              Vector store type: {selectedVectorStore.type}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="tool-modal-no-selection">No Vector Store selected</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NodePalette;